import { createApp } from 'vue'
import App from './Index.vue'

import PrimeVue from 'primevue/config';
import Dialog from 'primevue/dialog';

let app = createApp(App);

app.use(PrimeVue);
app.component('Dialog', Dialog);

app.mount('#app');
